import { CURRENCIES } from 'const';
import companiesActions from 'store/companies/selectors';
import countriesActions from 'store/countries/selectors';
import districtsActions from 'store/districts/selectors';
import emiratesActions from 'store/emirates/selectors';
import filtersActions from 'store/filters/selectors';
import measurementsActions from 'store/measurements/selectors';
import metroActions from 'store/metro/selectors';
import placesActions from 'store/places/selectors';
import projectsActions from 'store/projects/selectors';
import catalogActions from 'store/catalog/selectors';
const parseMapCenterLonLat = (mapCenter) => {
    if (!mapCenter)
        return undefined;
    const lng = Number(mapCenter.longitude);
    const lat = Number(mapCenter.latitude);
    if (!Number.isFinite(lng) || !Number.isFinite(lat))
        return undefined;
    return [lng, lat];
};
export const getCountryMapCenterLonLat = (country) => (parseMapCenterLonLat(country?.settings?.mapCenter));
export const getCountryMapInitOptions = (country) => {
    const center = getCountryMapCenterLonLat(country);
    if (!center)
        return undefined;
    const apiMinZoom = country?.settings?.mapCenter?.minZoom;
    return {
        center,
        minZoom: Number(apiMinZoom),
    };
};
export const applyCurrentCountryMeasurements = (country, measurementsState) => {
    const { code, settings } = country;
    const priceMeasurement = CURRENCIES.includes(settings.currencyCode) ? settings.currencyCode : 'USD';
    measurementsActions.setMeasurements({ type: 'countryCode', val: code });
    measurementsActions.setMeasurements({ type: 'countryName', val: country.name });
    measurementsActions.setMeasurements({ type: 'currencyCode', val: settings.currencyCode });
    measurementsActions.setMeasurements({ type: 'priceMeasurement', val: measurementsState?.priceMeasurement || priceMeasurement });
    measurementsActions.setMeasurements({ type: 'squareMeasurement', val: measurementsState?.squareMeasurement || settings.measurement });
};
// Перезагрузка данных карты после смены страны
export const reinitializeAppAfterCountryChange = async () => {
    projectsActions.setSelected(undefined);
    districtsActions.setSelected(undefined);
    placesActions.setSelected(undefined);
    filtersActions.clearFilters(undefined);
    await catalogActions.getLastCatalog(undefined);
    await Promise.all([
        emiratesActions.getEmirates(undefined),
        districtsActions.getDistricts(undefined),
        placesActions.getPlaces(undefined),
        companiesActions.getCompanies(undefined),
        metroActions.getMetro(undefined),
        countriesActions.getAvailableContinents(undefined),
    ]);
};
